import BookEdition from "components/editions/BookEdition";
import Button from "hardcover-ui/components/Button";
import Text from "hardcover-ui/components/Text";
import Icon from "hardcover-ui/components/Icon";
import faPlus from "icons/solid/plus.svg";
import classNames from "lib/classNames";
import { EditionSerializersEdition, PageSerializersBooksLayout } from "types/serializers";
import useCurrentUserId from "hooks/user/useCurrentUserId";

export interface Props {
  book: PageSerializersBooksLayout;
  editions: EditionSerializersEdition[];
}

export default function BookEditions({ book, editions }: Props) {
  const userId = useCurrentUserId();

  if (editions.length === 0) {
    return (
      <>
        <Text
          variant="secondary"
          size="lg"
          as="p"
          className="text-center my-8 italic"
        >
          Doesn't look like we have any editions for this book.
        </Text>

        <div className="mt-8">
          <Button
            variant="primary"
            size="md"
            as={{
              element: "link",
              props: {
                href: `/books/${book.slug}/editions/new`,
              },
            }}
          >
            <Icon icon={faPlus} size="lg" />
            <span>Add an Edition</span>
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="my-4">
      <div className="divide-y divide-secondary">
        {editions.map((edition) => (
          <BookEdition
            key={`edition-${edition.id}`}
            book={book}
            edition={edition}
          />
        ))}
      </div>

      <div
        className={classNames(
          "flex mt-12",
          userId > 0 ? "justify-between" : "justify-center"
        )}
      >
        {userId > 0 ? (
          <Button
            variant="primary"
            size="md"
            as={{
              element: "link",
              props: {
                href: `/books/${book.slug}/editions/new`,
              },
            }}
          >
            <Icon icon={faPlus} size="lg" />
            <span>Add an Edition</span>
          </Button>
        ) : (
          false
        )}
      </div>
    </div>
  );
}
